import React from 'react';

import { withRouter } from 'react-router-dom';
import 'react-dropdown/style.css';
import Amplify from 'aws-amplify';
import isEmpty from 'lodash/isEmpty';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as SecretKeys from '../../ENV.json';
import 'react-phone-number-input/style.css';
import 'react-responsive-ui/style.css';

import {
  saveBusinessUser,
  saveBusinessUserStep1,
  getAllCountry,
  getAllStates,
  getCityByStateId,
  getAllPlans,
  getAffiliateDetailByAffiliateKey,
  confirmUserEmail,
  clearData,
  getBusiness,
  getIndustry,
  checkEmailVerify,
  getPageData,
  requestApiData,
  clearDataEmail,
  clearSignupData,
} from '../../Actions/actions';

import TextFieldGroupPartner from '../common/TextFieldGroupPartner';
import EmailGroupPartner from '../common/emailInputField';

Amplify.configure(SecretKeys.awsUserpool);

class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      passwordType: 'password',
    };
  }

  handleSubmitSignup = (e) => {
    e.preventDefault();
    const { finalSubmit } = this.props;
    finalSubmit();
  };

  viewPassword = () => {
    if (this.state.passwordType === 'password') {
      this.setState({ passwordType: 'text' });
    } else {
      this.setState({ passwordType: 'password' });
    }
  };

  AckOnchange = (e) => {
    this.props.AckOnchangeCheckbox(e.target.name, e.target.checked);
  };

  render() {
    const {
      email,
      errorNumberPassword,
      errorUpperCasePassword,
      errorLimitPassword,
      errorSpecialPassword,
      errorLowerCasePassword,
      errorsSignup,
      onChangeEmail,
      password,
      onChange,
      emailVerifyData,
      isConsumer,
      cNotification,
      cUpdateClaim,
      cTermsandCondition,
      showTabBlock,
      activeTabList,
      tabClick,
    } = this.props;

    const { passwordType } = this.state;

    return (
      <div className='signup-tab-align'>
        <div
          id='signup-tab'
          className='col s12 main-content signup-new-tabs-content pad-x-none pad-15-mob'
        >
          <div className='tab-inner consumer-step1'>
            <h4 className='center-align signup-title ibmfont'>
              Create Account
            </h4>
            <p className='center-align signup-title2 font-medium ibmfont'>
              Sign up to easily file claims and collect funds{' '}
              {isConsumer ? '' : 'with Collectively.'}{' '}
            </p>
            {showTabBlock === 'Both' ? (
              <div className='btn-outer center-align col s12 l12 pad-x-none create-acc-btn-tabs'>
                <button
                  onClick={() => tabClick(1)}
                  className={
                    activeTabList === 1
                      ? 'waves-effect waves-light btn-blue ibmfont btn-tab '
                      : 'waves-effect waves-light ltgrey-btn btn-transparent ibmfont'
                  }
                  type='submit'
                  name='action'
                >
                  I am a business representative
                </button>
                <button
                  onClick={() => tabClick(0)}
                  className={
                    activeTabList === 0
                      ? 'waves-effect waves-light btn-blue ibmfont '
                      : 'waves-effect waves-light ltgrey-btn btn-transparent ibmfont'
                  }
                  type='submit'
                  name='action'
                >
                  I am a consumer
                </button>
              </div>
            ) : (
              ''
            )}
            <div className='row'>
              <div className='col s12 no-upfront-cost'>
                {isConsumer ? (
                  <p className='center-align upfront-cost font-medium pb-10'>
                    <span>No upfront cost</span> - Collectively keeps 19.95% of
                    collected funds
                  </p>
                ) : (
                  ''
                )}
              </div>
            </div>
            <div className='row'>
              <form
                className='col s12 l12 ibmfont pad-x-none mb-none'
                autoComplete='off'
              >
                <div className='row'>
                  {/* <input id="Email" type="text" placeholder="placeholder" className="validate" /> */}
                  <EmailGroupPartner
                    field='email'
                    label='Email'
                    value={email}
                    error={
                      isEmpty(errorsSignup)
                        ? emailVerifyData &&
                          emailVerifyData.collectMessage &&
                          emailVerifyData.collectMessage.messageShort ===
                            'User email already exist'
                          ? 'Email address already exists'
                          : ''
                        : errorsSignup.email
                    }
                    onChange={onChangeEmail}
                    forceNotifyByEnter={true}
                    // checkUserExists={this.verifyEmail}
                    divClassName='input-field col s12 pb-10 pad-x-none mb-24'
                    req
                  />
                  <TextFieldGroupPartner
                    field='password'
                    label='Password'
                    value={password}
                    error={errorsSignup.password}
                    onChange={onChange}
                    type={passwordType}
                    placeholder=''
                    passwordStatus={true}
                    checkUserExists={this.verifyEmail}
                    viewPassword={this.viewPassword}
                    divClassName='input-field col s12'
                    req
                  />

                  {/* <div className="input-field col s12">
                          <input id="Password" type="text" placeholder="placeholder" className="validate" />
                          <label htmlFor="Password">Password</label>
                        </div> */}
                  <div className='input-field col s12 psw-requirement pad-x-none'>
                    <h6 className='ibmfont signup-password-requirements'>
                      Password Requirements
                    </h6>
                    <ul className='row ibmfont psw-requirement-list'>
                      <li
                        className={`${
                          errorLowerCasePassword ? 'grey-out' : 'grey-black'
                        }`}
                      >
                        {errorLowerCasePassword ? (
                          <i className='tiny material-icons checkbox'>check</i>
                        ) : (
                          <i className='material-icons'>brightness_1</i>
                        )}
                        {/* <i className="tiny material-icons checkbox">check</i>
                                        <i class="material-icons" style="font-size: 0.5rem;">brightness_1</i> */}{' '}
                        1 lowercase letter
                      </li>
                      <li
                        className={`${
                          errorNumberPassword ? 'grey-out' : 'grey-black'
                        }`}
                      >
                        {errorNumberPassword ? (
                          <i className='tiny material-icons checkbox'>check</i>
                        ) : (
                          <i className='material-icons'>brightness_1</i>
                        )}{' '}
                        1 number
                      </li>
                      <li
                        className={` ${
                          errorSpecialPassword ? 'grey-out' : 'grey-black'
                        }`}
                      >
                        {errorSpecialPassword ? (
                          <i className='tiny material-icons checkbox'>check</i>
                        ) : (
                          <i className='material-icons'>brightness_1</i>
                        )}{' '}
                        1 special character
                      </li>
                      <li
                        className={` ${
                          errorUpperCasePassword ? 'grey-out' : 'grey-black'
                        }`}
                      >
                        {errorUpperCasePassword ? (
                          <i className='tiny material-icons checkbox'>check</i>
                        ) : (
                          <i className='material-icons'>brightness_1</i>
                        )}{' '}
                        1 uppercase letter
                      </li>
                      <li
                        className={` ${
                          errorLimitPassword ? 'grey-out' : 'grey-black'
                        }`}
                      >
                        {errorLimitPassword ? (
                          <i className='tiny material-icons checkbox'>check</i>
                        ) : (
                          <i className='material-icons'>brightness_1</i>
                        )}{' '}
                        8 characters minimum
                      </li>
                    </ul>
                  </div>
                  {isConsumer ? (
                    <div className='row consumer-checkbox'>
                      <h6 className='col s12 text-uppercase checkbox-below pad-x-none'>
                        check the boxes below to continue
                      </h6>
                      <div className='col s12 checkbox-color consumer-checkbox-inner pad-x-none'>
                        <label>
                          <input
                            type='checkbox'
                            name='cNotification'
                            onChange={this.AckOnchange}
                            value='1'
                            checked={cNotification === '1'}
                          />
                          <span>
                            I agree that you may notify me of product updates by
                            email.
                          </span>
                        </label>
                      </div>
                      <div className='col s12 checkbox-text checkbox-color consumer-checkbox-inner pad-x-none'>
                        <label>
                          <input
                            type='checkbox'
                            name='cUpdateClaim'
                            onChange={this.AckOnchange}
                            value='1'
                            checked={cUpdateClaim === '1'}
                          />
                          <span>
                            For Collectively to transfer settlement funds to me,
                            I understand that I must have a U.S bank or
                            investment account that complies with applicable
                            laws and regulations. Collectively only transfers
                            funds electronically--checks will not be issued.
                          </span>
                        </label>
                      </div>
                      <div className='col s12 checkbox-color pad-x-none consumer-checkbox-inner'>
                        <label>
                          <input
                            type='checkbox'
                            name='cTermsandCondition'
                            onChange={this.AckOnchange}
                            value='1'
                            checked={cTermsandCondition === '1'}
                          />
                          <span>
                            I understand that Collectively will withold a
                            service fee of 19.95% from the proceeds of any
                            successful claim.
                          </span>
                        </label>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}

                  <div className='col s12 center-align signup-first-step'>
                    <p className='ibmfont steps-signup-bottom'>
                      Additional steps are needed before your registration is
                      complete
                    </p>
                    <button
                      disabled={
                        !(
                          isEmpty(errorsSignup) &&
                          emailVerifyData &&
                          emailVerifyData.collectMessage &&
                          emailVerifyData.collectMessage.messageShort !==
                            'User email already exist'
                        )
                      }
                      className={
                        !(
                          isEmpty(errorsSignup) &&
                          emailVerifyData &&
                          emailVerifyData.collectMessage &&
                          emailVerifyData.collectMessage.messageShort !==
                            'User email already exist'
                        )
                          ? 'waves-effect waves-light ltgrey-btn col s12 btn-pink ibmfont'
                          : ' waves-effect waves-light pink-btn col s12'
                      }
                      type='submit'
                      name='action'
                      onClick={this.handleSubmitSignup}
                    >
                      Next
                    </button>
                  </div>
                  <div className='col s12' />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Signup.contextTypes = {
  router: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  data: state.data,
  signupData: state.signupData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveBusinessUser,
      saveBusinessUserStep1,
      getAllCountry,
      getAllStates,
      getCityByStateId,
      getAffiliateDetailByAffiliateKey,
      getAllPlans,
      confirmUserEmail,
      clearData,
      getIndustry,
      getBusiness,
      checkEmailVerify,
      requestApiData,
      getPageData,
      clearDataEmail,
      clearSignupData,
    },
    dispatch
  );
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Signup));
